import VSwitch from './VSwitch'

/* istanbul ignore next */
VSwitch.install = function install (Vue) {
  Vue.component(VSwitch.name, VSwitch)
}

export default VSwitch



// WEBPACK FOOTER //
// ./src/components/VSwitch/index.js